"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingValidationPrompt = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var axios_1 = __importDefault(require("axios"));
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var __generated__1 = require("../../../../../../shared/api/kapi/v1/__generated__/");
var meter_photo_1 = require("../../../../../../shared/api/kapi/v1/operations/meter-photo");
var core_1 = require("../../../../../../shared/core");
var components_1 = require("../../../../../../shared/core/components");
var MeterPhotoContext_1 = require("../../../../MeterPhotoContext");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var components_2 = require("../../../../components");
var AddMeterPhoto_1 = require("../../../../components/AddMeterPhoto/AddMeterPhoto");
var RegisterReading_styled_1 = require("../../../../components/RegisterReading/RegisterReading.styled");
var SupplyPointSummary_styled_1 = require("../../../../components/SupplyPointSummary/SupplyPointSummary.styled");
var constants_1 = require("../../../../constants");
var copy_1 = require("../../../../copy");
var errors_1 = require("../../../../data/mapping/errors");
var utils_1 = require("../../../../utils");
var MeterReadingValidationPrompt_styled_1 = require("./MeterReadingValidationPrompt.styled");
function formatMeterPhotoReading(data) {
    var reads = (0, utils_1.formatReads)(data);
    if ('peakMeterReading' in reads) {
        return reads.peakMeterReading;
    }
    return Object.keys(reads)[0];
}
function MeterReadingValidationPrompt(_a) {
    var _b, _c;
    var _this = this;
    var accountId = _a.accountId, data = _a.data, thresholdError = _a.thresholdError, onSubmit = _a.onSubmit, onCancel = _a.onCancel, isInProgress = _a.isInProgress, numOfDigits = _a.numOfDigits;
    var _d = (0, core_1.useComponents)(), Margin = _d.Margin, Card = _d.Card, PrimaryCTAButton = _d.PrimaryCTAButton, SecondaryCTAButton = _d.SecondaryCTAButton, ButtonGroup = _d.ButtonGroup, Heading1 = _d.Heading1;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var photoContext = (0, react_1.useContext)(MeterPhotoContext_1.MeterPhotoContext);
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var _e = __read((0, react_1.useState)(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    var handleImageChange = function (img) {
        photoContext.image = img;
    };
    var region = core_1.configService.getConfig().retailer.region;
    var errorMessage = (0, errors_1.getForceableErrorCopyKey)(thresholdError, data.dateTime);
    var _f = __read((0, meter_photo_1.useWriteMeterPhotoMutation)(), 1), submitMeterPhoto = _f[0];
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoading(true);
                    if (!!photoContext.image) return [3 /*break*/, 1];
                    // meter photo not mandatory
                    dispatch({
                        name: analytics_subjects_1.METER_PHOTO_NONE_SELECTED,
                        type: 'click',
                        properties: (_a = {},
                            _a[core_1.INTERNAL_EVENT_FLAG] = true,
                            _a),
                    });
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, submitMeterPhoto({
                        variables: {
                            input: {
                                accountId: accountId,
                                sprn: data.sprn,
                                mimeType: photoContext.image.type,
                                readDate: (0, date_fns_1.format)(Date.now(), constants_1.DATE_API_FORMAT),
                                contentLength: photoContext.image.size,
                                readValue: formatMeterPhotoReading(data),
                            },
                        },
                        onCompleted: function (urlData) { return __awaiter(_this, void 0, void 0, function () {
                            var url, err_1;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _c.trys.push([0, 2, 3, 4]);
                                        url = new URL(urlData.writeMeterPhoto.uploadUrl).toString();
                                        // don't use api-service because it adds headers S3 isn't expected
                                        return [4 /*yield*/, axios_1.default.put(url, photoContext.image)];
                                    case 1:
                                        // don't use api-service because it adds headers S3 isn't expected
                                        _c.sent();
                                        dispatch({
                                            name: analytics_subjects_1.METER_PHOTO_UPLOAD_SUCCESS,
                                            type: 'click',
                                            properties: (_a = {},
                                                _a[core_1.INTERNAL_EVENT_FLAG] = true,
                                                _a),
                                        });
                                        return [3 /*break*/, 4];
                                    case 2:
                                        err_1 = _c.sent();
                                        // if meter photo fails, just log it and carry on
                                        console.error('failed to upload', err_1);
                                        dispatch({
                                            name: analytics_subjects_1.METER_PHOTO_UPLOAD_ERROR,
                                            type: 'click',
                                            properties: (_b = {
                                                    error: err_1
                                                },
                                                _b[core_1.INTERNAL_EVENT_FLAG] = true,
                                                _b),
                                        });
                                        photoContext.hasError = false;
                                        return [3 /*break*/, 4];
                                    case 3:
                                        setIsLoading(false);
                                        return [7 /*endfinally*/];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); },
                        onError: function (err) {
                            var _a;
                            console.error("Failed to get photo upload url: ".concat(err));
                            dispatch({
                                name: analytics_subjects_1.METER_PHOTO_UPLOAD_ERROR,
                                type: 'click',
                                properties: (_a = {
                                        error: err
                                    },
                                    _a[core_1.INTERNAL_EVENT_FLAG] = true,
                                    _a),
                            });
                            setIsLoading(false);
                            // on writeMeterPhoto failure, continue read submission
                            photoContext.hasError = true;
                        },
                    })];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    onSubmit(__assign(__assign({}, data), { force: __generated__1.MeterReadForceType.Soft }));
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(Card, { "data-testid": "validation-prompt" },
        react_1.default.createElement(Heading1, null,
            react_1.default.createElement(Copy, { copyKey: 'validationPromptErrorNotificationTitle' })),
        react_1.default.createElement(MeterReadingValidationPrompt_styled_1.StyledCallout, { "data-testid": "error-summary-notification", id: "error-notification", variant: "warning" },
            react_1.default.createElement(Copy, { copyKey: errorMessage }),
            react_1.default.createElement(Copy, { copyKey: region === 'UK'
                    ? 'validationPromptCheckInfo'
                    : 'errorsServerOutsideThreshold' })),
        react_1.default.createElement(SupplyPointSummary_styled_1.StyledRegisterReadingsWrapper, null, data.registers.map(function (submitRegister, i) {
            var _a, _b, _c;
            var formattedPreviousRegisterReading = (0, utils_1.formatPreviousReading)(submitRegister.registerId, (_a = thresholdError.invalidAgainst) !== null && _a !== void 0 ? _a : undefined, numOfDigits);
            return (react_1.default.createElement(components_2.RegisterReading, { key: "".concat(submitRegister.registerId, "-").concat(i), timeOfUseLabel: submitRegister.timeOfUseLabel, date: formattedPreviousRegisterReading === null || formattedPreviousRegisterReading === void 0 ? void 0 : formattedPreviousRegisterReading.date, isEstimated: (_b = formattedPreviousRegisterReading === null || formattedPreviousRegisterReading === void 0 ? void 0 : formattedPreviousRegisterReading.isEstimated) !== null && _b !== void 0 ? _b : false, meterReading: (_c = formattedPreviousRegisterReading === null || formattedPreviousRegisterReading === void 0 ? void 0 : formattedPreviousRegisterReading.value) !== null && _c !== void 0 ? _c : '', isNew: false },
                react_1.default.createElement(ValidationReading, { readingValue: submitRegister.value, numOfDigits: numOfDigits, date: data.dateTime })));
        })),
        react_1.default.createElement(Margin, { vertical: [4, 8] },
            react_1.default.createElement(Copy, { copyKey: 'validationPromptReadingsWillBeChecked' })),
        react_1.default.createElement(ButtonGroup, null,
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READ_VALIDATION_CHANGE_READ, properties: (_b = {},
                    _b[core_1.INTERNAL_EVENT_FLAG] = true,
                    _b) },
                react_1.default.createElement(PrimaryCTAButton, { onClick: onCancel },
                    react_1.default.createElement(Copy, { copyKey: "validationPromptChange" }))),
            react_1.default.createElement(core_1.Feature, { feature: "meterPhoto" }, function (enabled) {
                return enabled ? (react_1.default.createElement(AddMeterPhoto_1.AddMeterPhoto, { onImageChange: handleImageChange })) : (react_1.default.createElement(react_1.default.Fragment, null));
            }),
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.METER_READ_VALIDATION_SUBMIT_READ, properties: (_c = {},
                    _c[core_1.INTERNAL_EVENT_FLAG] = true,
                    _c) },
                react_1.default.createElement(SecondaryCTAButton, { loading: isLoading, onClick: handleSubmit, type: "submit", disabled: isInProgress },
                    react_1.default.createElement(Copy, { copyKey: "validationPromptSubmit" }))))));
}
exports.MeterReadingValidationPrompt = MeterReadingValidationPrompt;
function ValidationReading(_a) {
    var readingValue = _a.readingValue, date = _a.date, numOfDigits = _a.numOfDigits;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var formatValidationReading = function (value) {
        return (react_1.default.createElement(MeterReadingValidationPrompt_styled_1.ErrorReading, null,
            react_1.default.createElement(components_1.Monospace, null, (0, utils_1.applyLeadingZeros)(numOfDigits, parseInt(value, 10)))));
    };
    var formattedDate = (0, date_fns_1.format)(date, constants_1.DATE_FORMAT);
    return (react_1.default.createElement(RegisterReading_styled_1.RegisterReadingContent, { "data-testid": "register-reading-validation" },
        react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingLabel, null, copy('validationPromptReadingYouEntered')),
        react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingDate, null, formattedDate),
        react_1.default.createElement(RegisterReading_styled_1.StyledRegisterReadingValue, null, formatValidationReading(readingValue))));
}
